import { fromJS } from 'immutable';
import { normalizeItems, findByIdFromIdsCollectionFn } from '@Utils';

import {
  saveAlertsType,
  removeAlertActionType,
  alertDeleteStartType,
  handleViewDeleteModalType,
  setRefetchType,
  setMountedType,
} from './AlertsConstants';

export const initialState = fromJS({
  refetch: false,
  showDeleteModal: false,
  alertIdToDelete: null,
  isDeleteInProgress: false,
  deletingAlertId: null,
});

export default function alertsReducer(state, action) {
  const currentState = state ?? initialState;

  switch (action.type) {
    case saveAlertsType: {
      const { alerts } = action.payload;
      const { items, ids } = normalizeItems(alerts);
      const nextState = currentState.set('items', fromJS(items));

      return nextState.set('ids', fromJS(ids));
    }

    case alertDeleteStartType: {
      const { id } = action.payload;
      const nextState = currentState.set('isDeleteInProgress', true);

      return nextState.set('deletingAlertId', id);
    }

    case handleViewDeleteModalType: {
      const { show, id } = action.payload;
      const nextState = currentState.set('showDeleteModal', show);

      return nextState.set('alertIdToDelete', id);
    }

    case removeAlertActionType: {
      const { id } = action.payload;
      const findFn = findByIdFromIdsCollectionFn(id);
      const stateWithUpdatedIds = currentState.update('ids', (ids) => {
        const requiredIdIndex = ids.findIndex(findFn);

        return ids.delete(requiredIdIndex);
      });
      const stateWithoutDeletedItem = stateWithUpdatedIds.deleteIn(['items', id]);
      const stateWithClosedModal = stateWithoutDeletedItem.set('showDeleteModal', false);
      const stateWithClearedModalAlert = stateWithClosedModal.set('alertIdToDelete', null);
      const stateWithDeleteDone = stateWithClearedModalAlert.set('isDeleteInProgress', false);

      return stateWithDeleteDone.set('deletingAlertId', null);
    }

    case setMountedType: {
      const { mounted } = action.payload;
      return currentState.set('mounted', mounted);
    }

    case setRefetchType: {
      const { refetch } = action.payload;
      return currentState.set('refetch', refetch);
    }

    default: {
      return currentState;
    }
  }
}
